import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/components/site/AuthContext";
import Landing from "@/components/site/Landing";
import Login from "@/components/site/Login";
import Admin from "@/components/site/Admin";
import ForgotPassword from "@/components/site/ForgotPassword";
import ResetPassword from "@/components/site/ResetPassword";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center" data-testid="auth-loading">
        <p className="text-slate-400 text-sm uppercase tracking-wider">Checking session...</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -96 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
